// Module
var code = "<span><span v-text=\"remaining\"></span></span>\n";
// Exports
export default code;